module.exports = __webpack_public_path__ + "img/VideoButtonMine.581443b8.png";